<template>
    <button type="submit" class="btn btn-primary" :disabled="isDisabled || isSaving">
        {{ title }}
        <div v-if="isSaving" class="ml-2 spinner-grow spinner-grow-sm" role="status"></div>
    </button>
</template>

<script>
export default {
    name: 'SubmitButton',
    props: {
        title: {
            type: String,
            default() {
                return 'Save'
            }
        },
        isDisabled: {
            type: Boolean,
            default() {
                return false
            }
        },
        isSaving: {
            type: Boolean,
            default() {
                return false
            }
        },
    },
};
</script>

